import { defineSlotRecipe } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/react/anatomy';

import {
  menuContentGapSm,
  menuContentMinWidth,
  menuContentPaddingLg,
  menuItemBorderRadius,
  menuItemIconSize,
  menuItemMinHeight,
} from './menu.kds';

/** KDS Menu — overrides Chakra `subtle` / `md` defaults only. */
export const menuSlotRecipe = defineSlotRecipe({
  slots: menuAnatomy.keys(),
  base: {
    content: {
      '--menu-bg': 'colors.neutral.0',
      alignItems: 'stretch',
      bg: 'neutral.0',
      borderWidth: '1px',
      borderColor: 'neutral.100',
      borderRadius: menuItemBorderRadius,
      boxShadow: 'menu',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    item: {
      alignItems: 'center',
      display: 'flex',
      width: '100%',
      borderRadius: menuItemBorderRadius,
      color: 'neutral.500',
      _disabled: {
        color: 'neutral.250',
        opacity: 1,
        '& svg': {
          color: 'neutral.250',
        },
      },
      '& svg': {
        boxSize: menuItemIconSize,
        flexShrink: 0,
      },
    },
    itemGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: menuContentGapSm,
      width: '100%',
    },
    itemGroupLabel: {
      p: menuContentGapSm,
      textStyle: 'small.medium',
      color: 'neutral.350',
      textTransform: 'uppercase',
    },
  },
  variants: {
    variant: {
      subtle: {
        item: {
          _highlighted: {
            bg: 'brand.50',
            color: 'neutral.500',
          },
          '&[data-state=checked]': {
            bg: 'brand.100',
            color: 'brand.500',
            '& svg': {
              color: 'brand.500',
            },
          },
        },
      },
    },
    size: {
      md: {
        content: {
          minW: menuContentMinWidth,
          px: menuContentPaddingLg,
          pt: menuContentPaddingLg,
          pb: menuContentPaddingLg,
          gap: menuContentGapSm,
          scrollPadding: menuContentGapSm,
        },
        item: {
          minH: menuItemMinHeight,
          p: menuContentGapSm,
          gap: menuContentGapSm,
          textStyle: 'default.regular',
        },
      },
    },
  },
});
